export const generatePassword = (initial) => {
  const processedInitial = initial.toLowerCase().replace(/\s/g, "");
  const password = processedInitial + "@tipkit";
  return password;
};
